import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-error"
}
const _hoisted_3 = { class: "text-caption mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showDialog) = $event)),
    "max-width": "720",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Save Secrets", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1,
                    __: [1]
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1,
            __: [2]
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (_ctx.submitError)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "error",
                    density: "compact",
                    class: "mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.submitError), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_alert, {
                type: "info",
                density: "compact",
                variant: "tonal",
                class: "mb-4"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" These secret values are stored privately for your account and are not shared with other users. ")
                ])),
                _: 1,
                __: [3]
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secretFields, (field) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: field.name,
                  class: "mb-4"
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createTextVNode(_toDisplayString(field.label) + " ", 1),
                    (field.required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(field.description), 1),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.values[field.name],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.name]) = $event),
                    type: "password",
                    variant: "outlined",
                    density: "compact",
                    label: field.label
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "px-4 pb-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1,
                __: [4]
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                color: "primary",
                loading: _ctx.submitting,
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Save Secrets")
                ])),
                _: 1,
                __: [5]
              }, 8, ["loading", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}